export const environment = {
    production: true,
    baseUrl: 'https://api.stat-wisee.srdi.net/',
    apiPath: '',
};